import styled from "@emotion/styled";
import { useIsMobile, useIsTablet } from "hooks/useDeviceType";

export const FilterContainer = styled.div(() => {
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();
  return {
    flexWrap: "wrap",
    width: "100%",
    minWidth: "420px", // Needed to prevent clear button forcing out of container
    "@media (max-width: 768px)": {
      "& > .token-filter": {
        flex: 1,
        flexBasis: "100%",
        maxWidth: "96vw",
      },
      "@media (min-width: 769px)": {
        flex: 0,
        flexBasis: "auto",
      },
    },
    minHeight: isMobile || isTablet ? "94px" : "45px",
    padding: isMobile ? "10px 0" : 0,
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    overflowX: "scroll",
    overflowY: "hidden",
    // Hide scrollbar
    msOverflowStyle: "none",
    scrollbarWidth: "none",
    "::-webkit-scrollbar": {
      display: "none",
    },
  };
});
